import styled from 'styled-components';
import * as colors from '../../../../common/colorConstants';

export const CustomerDetailsRow = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 12px;
`;

export const CustomerDetailsLabel = styled.label`
  font-size: 14px;
  color: ${colors.black1};
  font-weight: 400;
  margin-bottom: 0;
`;

export const CustomerDetailsWrapper = styled.div`
  position: relative;
`;

export const CustomerDetailsText = styled.div`
  color: ${colors.black4};
  font-size: 14px;
  line-height: 12px;
  padding: 4px;
`;

export const CustomerDetailsArrow = styled.div`
  margin: 0px 10px;
`;
